import { RefObject, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MachineFixing } from "../../interfaces/api/MachineFixing";
import { EpiId } from "../../shared/enums/LinkEpiId";
import { ProductType } from "../../shared/enums/ProductType";
import { productHelper } from "../../shared/helpers/productHelper";
import { useEpiserverLink } from "../../store/hooks/useEpiServerLink";
import { useMarket } from "../../store/hooks/useMarket";
import ListDesktop from "../shared/ListTable/ListDesktop";
import ListItem from "../shared/ListTable/ListItem";
import ListItemImage from "../shared/ListTable/ListItemImage";
import ListMobile from "../shared/ListTable/ListMobile";
import ListRow from "../shared/ListTable/ListRow";
import ListTable from "../shared/ListTable/ListTable";
import "./MachineFixingList.scss";

interface MachineFixingListProps {
  machineFixnings: MachineFixing[];
  onChange(machineFixing: MachineFixing): void;
  refMachineFixingList: RefObject<HTMLDivElement>;
  selectedMachineFixing: MachineFixing;
}

const MachineFixingList = ({
  machineFixnings,
  onChange,
  refMachineFixingList,
  selectedMachineFixing,
}: MachineFixingListProps) => {
  const market = useMarket();
  const { t } = useTranslation(["machinefixings", "metrics"]);
  const [episerverUrl, setEpiserverUrl] = useState<string>("");
  const episerverLinks = useEpiserverLink();

    useEffect(() => {
        if (episerverLinks && machineFixnings && machineFixnings.length > 0) {
            const url = `${process.env.REACT_APP_URLPATH}${episerverLinks[machineFixnings[0].epiId]
                }`;
            setEpiserverUrl(url);
        }
  }, [episerverLinks]);

  const isSelected = (machineFixningId: number): boolean => {
    if (!selectedMachineFixing) {
      return false;
    }
    return selectedMachineFixing.id === machineFixningId;
  };

  return (
    <div ref={refMachineFixingList}>
      <ListTable>
        {machineFixnings.map((machineFixning) => {
          const productData = productHelper.getProductData({
            market,
            product: machineFixning,
            productType: ProductType.MachineFixings,
            t,
          });

          return (
            <ListRow
              key={machineFixning.id}
              isSelected={isSelected(machineFixning.id)}
              identifier={machineFixning.id.toString()}
              object={machineFixning}
              onChange={(object) => {
                onChange(object as MachineFixing);
              }}
            >
              <>
                <ListDesktop
                  readMeText={t("readmore")}
                  readMeUrl={episerverUrl}
                >
                  <ListItemImage  product={productData} />
                  <ListItem
                    label={productData.nameLabel}
                    value={productData.name}
                  />
                  {productData.properties.map((property, index) => {
                    return (
                      <ListItem
                        key={`property-${index}`}
                        label={property.label}
                        value={property.text}
                      />
                    );
                  })}
                </ListDesktop>
                <ListMobile
                  content={productHelper.getHtmlContent(productData)}
                  imageLink={productData.imageLink}
                  isSelected={isSelected(machineFixning.id)}
                  object={machineFixning}
                  onChange={(object) => {
                    onChange(object as MachineFixing);
                  }}
                  preContent={productData.nameLabel}
                  readMeText={t("readmore")}
                  readMeUrl={episerverUrl}
                  title={productData.name}
                />
              </>
            </ListRow>
          );
        })}
      </ListTable>
    </div>
  );
};

export default MachineFixingList;
